import React, { Component } from "react";
import "./icons.scss";

class SvgInfo extends Component {
	render() {
		return (
			<span className="tooltip">
				<span className="tooltiptext">{this.props.description}</span>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					xmlnsXlink="http://www.w3.org/1999/xlink"
					version="1.1"
					x="0px"
					y="0px"
					viewBox={this.props.viewBox}
					style={this.props.style}
					xmlSpace="preserve"
				>
					<g>
						<path
							xmlns="http://www.w3.org/2000/svg"
							id="path-1"
							fill="#50c0e8"
							d="M 0.941176 8.00002 C 1.46097 8.00002 1.88235 8.4214 1.88235 8.94119 C 1.88235 9.461 1.46097 9.88237 0.941176 9.88237 C 0.421376 9.88237 5.42899e-014 9.461 5.42899e-014 8.94119 C 5.42899e-014 8.4214 0.421376 8.00002 0.941176 8.00002 Z M 0.941176 9.76996e-015 C 1.33104 9.76996e-015 1.64706 0.316047 1.64706 0.705882 L 1.64706 6.35296 C 1.64706 6.74282 1.33104 7.05884 0.941176 7.05884 C 0.551341 7.05884 0.235294 6.74282 0.235294 6.35296 L 0.235294 0.705882 C 0.235294 0.316047 0.551341 9.76996e-015 0.941176 9.76996e-015 Z"
						/>
						<path
							transform="translate(-9, -5)"
							xmlns="http://www.w3.org/2000/svg"
							id="path-3"
							fill="#50c0e8"
							d="M 10 18.8889 C 14.9092 18.8889 18.8889 14.9092 18.8889 10 C 18.8889 5.0908 14.9092 1.11111 10 1.11111 C 5.0908 1.11111 1.11111 5.0908 1.11111 10 C 1.11111 14.9092 5.0908 18.8889 10 18.8889 Z M 10 20 C 4.47715 20 0 15.5228 0 10 C 0 4.47715 4.47715 0 10 0 C 15.5228 0 20 4.47715 20 10 C 20 15.5228 15.5228 20 10 20 Z"
						/>
					</g>
				</svg>
			</span>
		);
	}
}

export default SvgInfo;
